import React from 'react';
import FadeIn from '../common/FadeIn';
import valueSectionImg from "../../assets/images/valueSection.png";
import { HiArrowLongDown } from "react-icons/hi2";
import laptop from "../../assets/images/laptop.png";
import phone from "../../assets/images/phone.png";
import rocket from "../../assets/images/rocket.png";

const ValuePropositionSection = () => {
  const features = [
    {
      title: "Smart & Affordable",
      description: "PROFESSIONAL DESIGN WITHOUT THE HIGH COST OF A FULLY CUSTOM WEBSITE.",
      icon: (
        <img
          src={laptop}
          alt="Laptop Icon - Web Design"
          className='w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 mx-auto mb-3 sm:mb-4 brightness-0 invert'
          loading="lazy"
          decoding="async"
          width="56"
          height="56"
        />
      )
    },
    {
      title: "Ready to Launch",
      description: "GET YOUR WEBSITE CUSTOMIZED, TESTED, AND READY TO GO IN DAYS, NOT WEEKS.",
      icon: (
        <img
          src={rocket}
          alt="Rocket Icon - Fast Launch"
          className='w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 mx-auto mb-3 sm:mb-4 brightness-0 invert'
          loading="lazy"
          decoding="async"
          width="56"
          height="56"
        />
      )
    },
    {
      title: "Personal Support",
      description: "FROM THE FIRST EDIT TO LAUNCH, YOU WILL HAVE DIRECT SUPPORT WHEN YOU NEED IT.",
      icon: (
        <img
          src={phone}
          alt="Phone Icon - Personal Support"
          className='w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 mx-auto mb-3 sm:mb-4 brightness-0 invert'
          loading="lazy"
          decoding="async"
          width="56"
          height="56"
        />
      )
    }
  ];

  return (
    <section className="w-full h-screen bg-[#050a02] text-white relative overflow-hidden flex flex-col items-center justify-center px-4 sm:px-8 md:px-12 lg:px-16 py-12 sm:py-16 md:py-20">
      <FadeIn className="absolute inset-0 w-full h-full">
        <img
          src={valueSectionImg}
          alt="SeaSalt Creative Value Proposition Showcase"
          className="w-full h-full object-cover opacity-55 pointer-events-none"
          loading="lazy"
          decoding="async"
          width="1920"
          height="1080"
        />
      </FadeIn>

      <div className="absolute bottom-0 left-0 right-0 h-36 sm:h-48 md:h-64 bg-gradient-to-b from-transparent via-[#050a02]/70 to-[#0D0C0B] pointer-events-none z-10" />

      <div className="container mx-auto relative z-20 w-full  text-center flex flex-col items-center justify-center px-2 sm:px-6">
        <FadeIn>
          <h1 className="font-saolDisplayItalic text-[30px] md:text-[55px] leading-[1.1] tracking-[0em] font-normal mx-auto">
            Your Website Does Not Need To Cost $10K.
          </h1>

          <div className="my-5 sm:my-6 md:my-8 text-center w-full">
            <HiArrowLongDown className='text-white w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 inline' />
          </div>

          <p className="font-interDisplayMedium text-[20px] md:text-[42px] leading-[1.4] tracking-[0em] font-normal max-w-[720px] md:max-w-[850px] lg:max-w-[920px] mx-auto mb-[45px]">
            Choose a design you like, and I will customize it with your content and brand.
          </p>
        </FadeIn>

        <FadeIn className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 md:gap-8 lg:gap-16 items-start justify-center">
            {features.map((feature, idx) => (
              <div key={idx} className="flex flex-col items-center text-center px-2 sm:px-4">
                {feature.icon}
                <h4 className="font-saolDisplayItalic text-[18px] lg:text-[28px] tracking-[0em] font-normal mb-[14px] capitalize">
                  {feature.title}
                </h4>
                <h3 className="font-interDisplayMedium text-[12px] lg:text-[14px] leading-[1.4] md:leading-[1.5] tracking-[0.05em] font-normal w-full max-w-[240px] sm:max-w-[260px] md:max-w-[280px] lg:max-w-[290px] mx-auto pt-1 sm:pt-2">
                  {feature.description}
                </h3>
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
